var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SF Symbol / chevron.right",
    d: "M8.15149e-07 10C8.38627e-07 9.73144 0.0966805 9.49512 0.300782 9.29101L8.81934 0.96582C9.00195 0.772461 9.23828 0.675781 9.51758 0.675781C10.0762 0.675781 10.5059 1.09473 10.5059 1.65332C10.5059 1.93262 10.3877 2.16895 10.2158 2.35156L2.39551 10L10.2158 17.6484C10.3877 17.8311 10.5059 18.0781 10.5059 18.3467C10.5059 18.9053 10.0762 19.3242 9.51758 19.3242C9.23828 19.3242 9.00195 19.2275 8.81934 19.0449L0.300782 10.709C0.0966805 10.5156 7.91671e-07 10.2686 8.15149e-07 10Z",
    fill: "#0B1838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.6bba775971ad056889f28c39a55bb466.svg";
export { ForwardRef as ReactComponent };